import { useLocation, Outlet } from 'react-router-dom';
import SearchDemand from "../Pages/SearchDemand/SearchDemand";

const ApplicantLayout = () => {
    const location = useLocation();

    return (
        <div className="main-layout">
            <div style={{
                display: location.pathname === '/applicant' ? 'block' : 'none',
            }}>
                <SearchDemand />
            </div>

            <Outlet />
        </div>
    );
};

export default ApplicantLayout